import Vue from 'vue'
import ConfirmComponent from '@/components/Confirm.vue'

const ConfirmConstructor = Vue.extend(ConfirmComponent)

let instance = null

const Confirm = {
  install(Vue) {
    Vue.prototype.$confirm = function(message) {
      if (!instance) {
        instance = new ConfirmConstructor()
        instance.$mount()
        document.body.appendChild(instance.$el)
      }
      return instance.show(message)
    }
  }
}

export default Confirm
